import script from "./ChartSquareBarIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartSquareBarIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__